import { motion } from 'framer-motion'
import { Heart, Info } from 'lucide-react'

export function EventFee() {
  return (
    <section>
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl font-dancing font-bold mb-4 text-gray-800">Participation Fee</h2>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          <motion.div
            className="fairy-card p-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <div className="mb-6">
              <div className="flex items-center gap-4 mb-2">
                <div className="p-3 bg-gradient-orange-to-pink rounded-full text-white">
                  <Heart className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-semibold text-gray-800">ご祝儀について</h3>
              </div>
              <p className="text-gray-600 ml-16">
                おふたりの門出を祝う気持ちだけで十分です。<br />
                ご祝儀はご辞退させていただいております。
              </p>
            </div>

            <div className="mb-6">
              <div className="flex items-center gap-4 mb-2">
                <div className="p-3 bg-gradient-orange-to-pink rounded-full text-white">
                  <Info className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-semibold text-gray-800">参加費（飲食代）</h3>
              </div>
              <p className="text-gray-600 mb-3 ml-16">
                当日は参加費として<span className="font-bold text-lg">15,000円</span>をを頂戴いたします。
                <br />
                高校生以下の方の参加費は不要です。<br />
                こちらで食事をご用意させていただきます。<br />
                ・中学生、高校生は大人の方と同じコースメニューとなります。<br />
                ・小学生以下はお子様用のお食事をご用意させていただきます。<br />
                フォームでお名前を入力後、「お子様用の食事を希望」にチェックをお願いします。<br />
                <br />
              </p>
              <div className="bg-orange-50 p-4 rounded-lg border border-orange-200 ml-16">
                <p className="text-sm text-orange-800">
                  お釣りのないようご準備いただけますと幸いです。
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
